import { takeEvery, takeLatest, all, put, call, select } from 'redux-saga/effects';
import { wallet, loading, toast, modal, auth, serviceRequest } from '../types';
import iceberg_apis from '../iceberg_apis';

export function* getWalletsDetails(action) {
    try {
        const response = yield call(iceberg_apis.wallet.get, {});
        if (response.status === 200) {
            yield put({ type: wallet.GET_WALLETS_DETAILS_SUCCESS, payload: response.data });
        }

    } catch (error) {
        console.log('error:', error)

    }
}
export function* createWalletsDetails(action) {
    try {
        const response = yield call(iceberg_apis.wallet.create, {});
        if (response.data.code === 200) {
            yield put({ type: wallet.GET_WALLETS_DETAILS_SUCCESS, payload: response.data.data });
        }

    } catch (error) {
        console.log('error:', error)

    }
}
export function* getMyWallet(action) {

    try {
        const response = yield call(iceberg_apis.wallet.getMyWallet, {});
        if (response.status === 200) {
            yield put({ type: wallet.GET_MY_WALLET_SUCCESS, payload: response.data });
        }

    } catch (error) {
        console.log('error:', error)

    }
}
export function* getProviderBalance(action) {
    let { type = 'PAYOUT', org_id } = action.payload;
    if (!org_id) {
        const newLoggedUserData = yield select((state) => state.auth.newLoggedUserData);
        org_id = newLoggedUserData.org.id;
    }
    try {
        yield put({ type: loading.SET_PROVIDER_BALANCE_LOADING, payload: true });
        const response = yield call(iceberg_apis.wallet.getProviderBalance, {}, {}, { type, org_id });
        if (response.status === 200) {
            yield put({ type: wallet.GET_WALLETS_DETAILS_SUCCESS, payload: response.data });
        }

    } catch (error) {
        console.log('error:', error)

    } finally {
        yield put({ type: loading.SET_PROVIDER_BALANCE_LOADING, payload: false });
    }
}
export function* withdrawFromWallet(action) {
    const { data, formName, cleanUp, callGetMe = false, callUserWalletDetails = false } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(iceberg_apis.wallet.withdarwFromWallet, {}, {}, {}, data);
        if (response.status === 200) {
            if (cleanUp) {
                yield put({ type: wallet.WITHDRAW_FROM_WALLET_OTP_SUCCESS, payload: false });
            }
            if (callGetMe) yield put({ type: auth.USER_PROFILE_REQUEST, payload: { navigate: () => { }, callPreference: false } });
            if (callUserWalletDetails) {
                yield put({ type: wallet.GET_USER_WALLET_BY_ID_SUCCESS, payload: { wallet: undefined, userId: data?.beneficiary } })
                yield put({ type: wallet.GET_USER_WALLET_BY_ID_REQUEST, payload: { userId: data?.beneficiary } });
            }
            yield put({ type: modal.CLOSE_MODAL });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message } })
            yield put({ type: wallet.REFRESH_WALLET_TRANSACTION_REQUEST })
        }

    } catch (error) {
        console.log('error:', error)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response.data.messages[0] || 'Somthing Went Wrong' } })

    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}
export function* transferFromWallet(action) {
    const { data } = action.payload;
    try {
        const response = yield call(iceberg_apis.wallet.transferFromWallet, {}, {}, {}, data);
        if (response.status === 200) {
            yield put({ type: modal.CLOSE_MODAL })
            yield put({ type: wallet.GET_WALLETS_DETAILS_SUCCESS, payload: response.data.data });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message } })
            yield put({ type: wallet.REFRESH_WALLET_TRANSACTION_REQUEST })
        }

    } catch (error) {
        console.log('error:', error)

        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response.data.messages } })

    }
}
export function* transferFromWalletToBank(action) {
    const { data, formName, refreshPayments = false, ticketId, roles, org_id } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(iceberg_apis.wallet.transferFromWalletToBank, {}, {}, {}, data);
        if (response.status === 200) {
            if (refreshPayments) {
                yield put({ type: serviceRequest.GET_SERVICE_REQUEST_PAYMENTS_REQUEST, payload: { ticketId, payload: {}, roles, org_id } })
            }
            yield all([
                put({ type: modal.CLOSE_MODAL }),
                put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response?.data?.message || 'Successfully initiated the money transfer.' } })
            ])
        }
    } catch (error) {
        console.log('error:', error)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response.data.messages[0] || 'Somthing Went Wrong' } })

    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}
export function* getTransactionList(action) {
    const { limit, page, query, payload = {} } = action.payload;

    try {
        if (page === 1) {
            yield put({ type: loading.SET_TRANSACTION_LIST_LOADING, payload: true });
        } else {
            yield put({ type: loading.SET_NEXT_TRANSACTION_LIST_LOADING, payload: true })
        }
        const response = yield call(iceberg_apis.transactions.getListTransaction, {}, {}, { limit, page, q: query, ...payload }, {});
        if (response.status === 200) {
            yield put({ type: wallet.GET_TRANSACTION_LIST_SUCCESS, payload: { data: response.data, page } });
        }

    } catch (error) {
        console.log('error:', error)

    }
    if (page === 1) {

        yield put({ type: loading.SET_TRANSACTION_LIST_LOADING, payload: false });
    } else {
        yield put({ type: loading.SET_NEXT_TRANSACTION_LIST_LOADING, payload: false })
    }
}

export function* checkTransactionStatus(action) {
    const { id, formName, source, ticketId } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(iceberg_apis.transactions.checkTransactionStatus, {}, { id });
        if (response.status === 200) {
            if (source === 'additional_payment_card') {
                yield put({ type: wallet.UPDATE_ADDITIONAL_PAYMENT_DETAILS, payload: { data: response.data, ticketId } });
            } else if (source === 'wallet_card') {
                yield put({ type: wallet.CHECK_TRANSACTION_STATUS_SUCCESS, payload: response.data });
            } else if (source === 'withdrawal_table') {
                yield put({ type: wallet.UPDATE_WALLET_TRANSACTION_REQUEST, payload: { data: response.data } });
            }
        }

    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response.data.messages[0] || 'Somthing Went Wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}
export function* addMoneyToWallet(action) {
    const { data, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(iceberg_apis.wallet.addMoneyToWallet, {}, {}, {}, data);
        if (response.status === 200) {
            yield put({ type: wallet.ADD_MONEY_TO_WALLET_SUCCESS, payload: response.data });
            yield put({ type: modal.CLOSE_MODAL })
        }

    } catch (error) {
        console.log('error:', error)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response.data.messages[0] || 'Somthing Went Wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}
export function* withdrawFromWalletOtp(action) {
    const { formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(iceberg_apis.wallet.withdrawFromWalletOtp, {}, {}, {}, {});
        if (response.status === 200) {
            yield put({ type: wallet.WITHDRAW_FROM_WALLET_OTP_SUCCESS, payload: true });
        }
    } catch (error) {
        console.log('error:', error)
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}

export function* refreshWalletTransaction(action) {
    yield put({ type: wallet.GET_TRANSACTION_LIST_REQUEST, payload: { limit: 10, page: 1, query: '', payload: {} } });
}

export function* getUserWalletDetailsById(action) {
    const { userId } = action.payload;
    try {
        yield put({ type: loading.GET_USER_WALLET_BY_ID_LOADING, payload: true });
        const response = yield call(iceberg_apis.wallet.detailsById, {}, { userId }, {}, {});
        if (response.status === 200) {
            yield put({ type: wallet.GET_USER_WALLET_BY_ID_SUCCESS, payload: { wallet: response.data, userId } });
        }
    } catch (error) {
        console.log('error:', error)
    } finally {
        yield put({ type: loading.GET_USER_WALLET_BY_ID_LOADING, payload: false });
    }
}

export function* getTransactionFilterList(action) {
    const { filter_labels, q, formName } = action.payload;
    const query = { filter_labels };
    if (q) query.q = q;
    if (!q) {
        yield put({ type: loading.WITHDRAWL_FILTER_LIST_LOADING, payload: true })
    } else if (q && formName) {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
    }
    try {
        const response = yield call(iceberg_apis.transactions.getFilterListTransaction, {}, {}, query, {});
        if (response.status === 200) {
            yield put({ type: wallet.GET_TRANSACTION_FILTER_LIST_SUCCESS, payload: { data: response.data, q } });
        }

    } catch (error) {
        console.log('error:', error)
    }
    if (!q) {
        yield put({ type: loading.WITHDRAWL_FILTER_LIST_LOADING, payload: false })
    } else if (q && formName) {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}

export default function* walletSaga() {
    yield takeEvery(wallet.GET_WALLETS_DETAILS_REQUEST, getWalletsDetails);
    yield takeEvery(wallet.CREATE_WALLET_REQUEST, createWalletsDetails);
    yield takeEvery(wallet.GET_MY_WALLET_REQUEST, getMyWallet);
    yield takeEvery(wallet.GET_PROVIDER_BALANCE_REQUEST, getProviderBalance);
    yield takeEvery(wallet.WITHDRAW_FROM_WALLET_REQUEST, withdrawFromWallet);
    yield takeEvery(wallet.TRANSFER_FROM_WALLET_REQUEST, transferFromWallet);
    yield takeEvery(wallet.TRANSFER_FROM_WALLET_TO_BANK_REQUEST, transferFromWalletToBank);
    yield takeLatest(wallet.GET_TRANSACTION_LIST_REQUEST, getTransactionList);
    yield takeLatest(wallet.CHECK_TRANSACTION_STATUS_REQUEST, checkTransactionStatus);
    yield takeEvery(wallet.ADD_MONEY_TO_WALLET_REQUEST, addMoneyToWallet);
    yield takeEvery(wallet.WITHDRAW_FROM_WALLET_OTP_REQUEST, withdrawFromWalletOtp);
    yield takeLatest(wallet.REFRESH_WALLET_TRANSACTION_REQUEST, refreshWalletTransaction);
    yield takeEvery(wallet.GET_USER_WALLET_BY_ID_REQUEST, getUserWalletDetailsById);
    yield takeEvery(wallet.GET_TRANSACTION_FILTER_LIST_REQUEST, getTransactionFilterList);
}
